"use client";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useRef, useState } from "react";
import { AiOutlineClose, AiOutlineRobot } from "react-icons/ai";
import { FaCheck, FaRedo, FaTrash } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import Gmail from "../Assets/gmail.png";
import Phone from "../Assets/telephone.png";
import whatsapp from "../Assets/whatsapp.png";
import { handleError } from "../CommonJquery/CommonJquery";
import Breadcrumb from "../components/Breadcrumb";
import "../components/CSS/EvenListning.css";
import "../components/CSS/GenerateAi.css";
import { retrieveData, storeData } from "../LocalConnection/LocalConnection";
import MasterLayout from "../masterLayout/MasterLayout";
import {
  custom_bad_reviews_all,
  custom_favorite_reviews,
  custom_open_close_reviews,
  custom_update_archives_reviews,
  get_ai_smart_reply,
  refresh_platform_token,
  replay_on_review,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import StarRating from "../components/child/RatingStar";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
// import { retrieveData } from "../LocalConnection/LocalConnection";

function Reviews() {
  const location = useLocation();
  let { review_id } = location.state || {};
  // FIX: was `const { label } = location.state || "inbox"` which evaluated
  // to `"inbox".label` (always undefined) whenever location.state was missing.
  const label = location.state?.label;
  const [activeTab, setActiveTab] = useState("inbox");
  const [reviewOpen, setReviewOpen] = useState(null);
  const [reviewSelected, setReviewSelected] = useState([]);
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [replyText, setreplyText] = useState("");
  const [replyTextShow, setreplyTextShow] = useState("");
  const [replyTextState, setreplyTextState] = useState(false);
  const [showTeaxtarea, setshowTeaxtarea] = useState(false);
  const [replyDone, setreplydone] = useState(false);
  const [loaderResponse, setloaderResponse] = useState(false);
  const [startAnimAI, setstartAnimAI] = useState(false);
  const [start, setstart] = useState("");
  const [end, setend] = useState("");
  const navigate = useNavigate();
  // const [period, setperiod] = useState(retrieveData("Period"));
  const [filteredReviewsList, setfilteredReviewsList] = useState([]);
  const periodSelected = retrieveData("period");
  const adminName = retrieveData("final_full_name");
  const [errorMessage, setErrorMessage] = useState(null);
  const [fbErrorMessage, setfbErrorMessage] = useState(null);
  const lastOpenedRef = useRef(null);
  // console.log(periodSelected);
  useEffect(() => {
    handleDateSelection("", "", periodSelected);
  }, [periodSelected]);

  const handleDateSelection = (start, end, period) => {
    setReviews([]);
    setstart(start);
    setend(end);
    master_data_get(start, end, period);
  };

  const master_data_get_refresh_token = async () => {
    const formdata = new FormData();
    await server_post_data(refresh_platform_token, formdata)
      .then((Response) => {
        const data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);

          setErrorMessage(final_data.message);

          storeData("google_connect_stat", "1");
        } else {
          storeData("google_connect_stat", "0");
        }
      })
      .catch((error) => {
        console.log(error);
        handleError("network");
      });
  };

  useEffect(() => {
    if (review_id !== undefined && reviews.length > 0) {
      const selectedReview = reviews.find(
        (review) => review.bb_id === review_id,
      );
      if (selectedReview) {
        if (lastOpenedRef.current !== review_id) {
          lastOpenedRef.current = review_id;
          resetReplyStates();
          setreplyTextState(true);
        }
        setReviewOpen(review_id);
        setReviewSelected(selectedReview);
      }
    }

    if (label !== undefined) {
      lastOpenedRef.current = null;
      resetReplyStates();
      setActiveTab(label);
      setReviewOpen(null);
      setIsSelectAll(false);
      review_id = null;
      setCurrentPage(1);
    }
  }, [review_id, label, reviews]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setReviewOpen(null);
    setIsSelectAll(false);
    review_id = null;
    setCurrentPage(1);
    setreplydone(false);
    setSearchQuery("");
    setfilteredReviewsList([]);
  };

  const handleReviewClose = () => {
    lastOpenedRef.current = null;
    resetReplyStates();
    setReviewOpen(null);
    review_id = null;
  };

  const getInitials = (name) => {
    if (!name) return "";
    const parts = name.trim().split(" ").filter(Boolean);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    const firstInitial = parts[0][0];
    const lastInitial = parts[parts.length - 1][0];
    return (firstInitial + lastInitial).toUpperCase();
  };

  const master_data_get = async (start, end, period) => {
    setShowLoaderAdmin(true);
    const formdata = new FormData();
    formdata.append("from_date", start);
    formdata.append("to_date", end);
    formdata.append("click_type", period);
    await server_post_data(custom_bad_reviews_all, formdata)
      .then((Response) => {
        const data1 = Response.message.split("~@~");
        if (Number.parseInt(data1[0]) === 1) {
          handleError(data1[1]);
        } else {
          const final_data = JSON.parse(data1[1]);
          setReviews(final_data.month_nagtive);
          // NOTE: filteredReviewsList is only meant to hold SEARCH results
          // (see searchQueryFilter). Pre-filling it here with the full,
          // un-filtered dataset made every tab click show all reviews
          // instead of the tab-filtered list, because the render below
          // prioritizes filteredReviewsList whenever it's non-empty.
          setCurrentPage(1);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  const submit_review_replay = async (review_id) => {
    console.log("submit", review_id);

    if (replyText !== "") {
      setreplyTextShow(replyText);
      setShowLoaderAdmin(true);
      setloaderResponse(true);
      const formdata = new FormData();
      formdata.append("reviewId", reviewSelected.online_review_id);
      formdata.append("platform", reviewSelected.platform);
      formdata.append("replyText", replyText);
      formdata.append("rating", reviewSelected.rating);
      await server_post_data(replay_on_review, formdata)
        .then((Response) => {
          const data1 = Response.message.split("~@~");
          if (Number.parseInt(data1[0]) === 1) {
            handleError(data1[1]);
            setreplyTextState(false);
          } else {
            setreplyTextState(true);
            setshowTeaxtarea(true);
            setReviewOpen(review_id);
            master_data_get(start, end, periodSelected);
            setreplyTextShow(replyText);
            setshowPersonalAi(false);
            // setreplyText("");
          }
          setShowLoaderAdmin(false);
          setreplydone(true);
          setloaderResponse(false);
        })
        .catch((error) => {
          console.log(error);
          handleError("network");
          setShowLoaderAdmin(false);
        });
    }
  };
  const generate_reply = async (prompt) => {
    setstartAnimAI(true);
    // Cancel any ongoing typing simulation
    if (window.typingInterval) {
      clearInterval(window.typingInterval);
    }

    const formdata = new FormData();

    if (prompt) {
      formdata.append("prompt", prompt || "");
    }
    const effectiveMessage =
      reviewSelected.msg && reviewSelected.msg.trim() !== ""
        ? reviewSelected.msg
        : `Customer gave a rating of ${reviewSelected.rating || "N/A"}/5 without any written comments.`;

    formdata.append("user_message", effectiveMessage);
    formdata.append("user_name", reviewSelected.name_user);

    setreplyText(""); // Clear previous text
    setShowLoaderAdmin(true); // Show loader

    await server_post_data(get_ai_smart_reply, formdata)
      .then((Response) => {
        console.log(Response);
        const data1 = Response.data;
        if (Response.error) {
          handleError(Response.message);
        } else {
          console.log(data1);
          simulateTypingEffect(data1.smart_reply);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  const hasReplyableContent = (review) =>
    review.platform === "Google"
      ? true // Google: msg empty ho tab bhi allow (rating hi kaafi hai)
      : review.msg !== "";
  const simulateTypingEffect = (fullText) => {
    // Ensure fullText is properly defined and trimmed
    if (!fullText) {
      console.error("Empty text received");
      return;
    }

    fullText = fullText.trim();

    let index = 0;
    // Reset reply text completely
    setreplyText("");

    // Cancel any previous interval
    if (window.typingInterval) {
      clearInterval(window.typingInterval);
    }

    // Start a new interval
    window.typingInterval = setInterval(() => {
      if (index < fullText.length) {
        // Use functional update to ensure we're working with the latest state
        setreplyText((prev) => {
          // For the first character, ensure we're starting fresh
          if (index === 0) {
            return fullText.charAt(0);
          }
          return prev + fullText.charAt(index);
        });
        index++;
      } else {
        // Verify final text matches expected text
        setreplyText((prev) => {
          if (prev !== fullText) {
            setstartAnimAI(false);
            return fullText;
          }
          return prev;
        });
        clearInterval(window.typingInterval);
        window.typingInterval = null;
      }
    }, 30); // Adjust speed here (30ms per character)
  };

  const master_update_open = async (id, platform) => {
    setShowLoaderAdmin(true);
    const fd_from = new FormData();
    fd_from.append("ticket_id", id);
    fd_from.append("platform", platform);
    await server_post_data(custom_open_close_reviews, fd_from)
      .then((Response) => {
        setShowLoaderAdmin(false);
        const data1 = Response.message.split("~@~");
        if (Number.parseInt(data1[0]) === 1) {
          handleError(data1[1]);
        } else {
          master_data_get(start, end, periodSelected);
        }
      })
      .catch((error) => {
        console.log(error);
        setShowLoaderAdmin(false);
      });
  };

  const master_update_archive = async (id, fav, multi) => {
    setShowLoaderAdmin(true);
    const fd_from = new FormData();
    if (fav === "0") {
      fav = "1";
    } else {
      fav = "0";
    }
    fd_from.append("ticket_ids", id);
    fd_from.append("favorites", fav);
    fd_from.append("multi", multi); // 0 single & 1 loop
    await server_post_data(custom_update_archives_reviews, fd_from)
      .then((Response) => {
        setShowLoaderAdmin(false);
        const data1 = Response.message.split("~@~");
        if (Number.parseInt(data1[0]) === 1) {
          handleError(data1[1]);
        } else {
          master_data_get(start, end, periodSelected);
        }
      })
      .catch((error) => {
        console.log(error);
        setShowLoaderAdmin(false);
      });
  };

  const handlereviewChange = (e) => {
    setreplyText(e.target.value);
    console.log(e.target.value);
  };

  const resetReplyStates = () => {
    if (window.typingInterval) {
      clearInterval(window.typingInterval);
      window.typingInterval = null;
    }
    setreplyText("");
    setreplyTextShow("");
    setreplyTextState(false);
    setshowTeaxtarea(false);
    setreplydone(false);
    setloaderResponse(false);
    setstartAnimAI(false);
    setshowPersonalAi(false);
    setInputText("");
    setHasGenerated(false);
  };
  const handleReviewOpen = (reviewId, platform) => {
    lastOpenedRef.current = reviewId;
    resetReplyStates();
    setreplyTextState(true);
    setReviewOpen(reviewId);
    const selectedReview = reviews.find((review) => review.bb_id === reviewId);
    setReviewSelected(selectedReview);
    master_update_open(reviewId, platform);
  };

  const master_update_fav = async (id, fav, multi) => {
    setShowLoaderAdmin(true);
    const fd_from = new FormData();
    if (fav === "0") {
      fav = "1";
    } else {
      fav = "0";
    }
    console.log(id, fav);
    fd_from.append("ticket_ids", id);
    fd_from.append("favorites", fav);
    fd_from.append("multi", multi); // 0 single & 1 loop
    await server_post_data(custom_favorite_reviews, fd_from)
      .then((Response) => {
        setShowLoaderAdmin(false);
        const data1 = Response.message.split("~@~");
        if (Number.parseInt(data1[0]) === 1) {
          handleError(data1[1]);
          setErrorMessage(data1[1]);
        } else {
          master_data_get(start, end, periodSelected);
          // handleReviewOpen(reviewOpen)
        }
      })
      .catch((error) => {
        console.log(error);
        setShowLoaderAdmin(false);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoaderAdmin(true); // Show loader at the start
      try {
        await master_data_get_refresh_token();
      } catch (error) {
        handleError("network");
      } finally {
        setShowLoaderAdmin(false); // Hide loader after all calls
      }
    };
    fetchData();
  }, []);

  const formatReviewDate = (entryDate) => {
    const today = new Date();
    const reviewDate = new Date(entryDate);

    // Reset time to midnight for accurate date comparison
    const todayStart = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );
    const reviewStart = new Date(
      reviewDate.getFullYear(),
      reviewDate.getMonth(),
      reviewDate.getDate(),
    );

    const diffInDays = Math.floor(
      (todayStart - reviewStart) / (1000 * 60 * 60 * 24),
    );

    if (diffInDays === 0) {
      const hours = reviewDate.getHours().toString().padStart(2, "0");
      const minutes = reviewDate.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    } else if (diffInDays === 1) {
      return "Yesterday";
    } else {
      const currentYear = today.getFullYear();
      const reviewYear = reviewDate.getFullYear();

      // If the review is from last year, format as DD/MM/YYYY
      if (reviewYear < currentYear) {
        const day = reviewDate.getDate().toString().padStart(2, "0");
        const month = (reviewDate.getMonth() + 1).toString().padStart(2, "0"); // months are 0-indexed
        const year = reviewDate.getFullYear().toString().slice(-2);
        return `${day}/${month}/${year}`;
      } else {
        // Otherwise, format as month (short) day
        const options = { day: "numeric", month: "short" };
        return reviewDate.toLocaleDateString("en-US", options);
      }
    }
  };

  // Inbox = all non-archived reviews (not "not yet opened")
  const inboxCount = reviews.filter((review) => review.archives == "0").length;

  // Replied / Unreplied should also exclude archived reviews
  const replyCount = reviews.filter(
    (review) => review.reply_noreply == "1" && review.archives == "0",
  ).length;

  const unrepliedCount = reviews.filter(
    (review) => review.reply_noreply == "0" && review.archives == "0",
  ).length;

  const starsCount = reviews.filter(
    (review) => review.favorite == "1" && review.archives == "0",
  ).length;

  const archiveCount = reviews.filter(
    (review) => review.archives == "1",
  ).length;

  const [currentPage, setCurrentPage] = useState(1);
  const reviewsPerPage = 10;
  const starredReviews = reviews.filter((review) => review.favorite == "1");
  const repliedReviews = reviews.filter(
    (review) => review.reply_noreply == "1",
  );
  const unrepliedReviews = reviews.filter(
    (review) => review.reply_noreply == "0",
  );
  const archiveReviews = reviews.filter((review) => review.archives == "1");
  const googleReviews = reviews.filter(
    (review) => review.platform === "Google",
  );
  const facebookReviews = reviews.filter(
    (review) => review.platform === "Facebook",
  );

  const playstorereviews = reviews.filter(
    (review) => review.platform === "Android Play Store",
  );
  const wowReviews = reviews.filter(
    (review) => review.platform === "WowReview",
  );
  const tripadvisor = reviews.filter(
    (review) => review.platform === "Tripadvisor",
  );
  const positiveReviews = reviews.filter((review) => review.rating >= 3.5);
  const negativeReviews = reviews.filter((review) => review.rating <= 3.5);
  const reviewsFilter = reviews.filter((review) => review.archives == "0");

  // Reviews to display based on the active tab
  const filteredReviews =
    activeTab === "starred"
      ? starredReviews
      : activeTab === "replied"
        ? repliedReviews
        : activeTab === "unreplied"
          ? unrepliedReviews
          : activeTab === "archieves"
            ? archiveReviews
            : activeTab === "google"
              ? googleReviews
              : activeTab === "facebook"
                ? facebookReviews
                : activeTab === "tripadvisor"
                  ? tripadvisor
                  : // FIX: sidebar/handleSelectAll use "playstore" (lowercase, no space)
                    // but this used to check "Play Store", so the tab never matched.
                    activeTab === "playstore"
                    ? playstorereviews
                    : activeTab === "positive"
                      ? positiveReviews
                      : activeTab === "negative"
                        ? negativeReviews
                        : activeTab === "wowreview"
                          ? wowReviews
                          : reviewsFilter;

  // Pagination Logic
  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews = filteredReviews.slice(
    indexOfFirstReview,
    indexOfLastReview,
  );

  const totalPages = Math.ceil(filteredReviews.length / reviewsPerPage);

  // Handlers for Pagination
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const [searchQuery, setSearchQuery] = useState("");

  const searchQueryFilter = (searchData) => {
    if (searchQuery !== "") {
      const filterData = reviews.filter((review) => {
        const query = searchData.toLowerCase();
        const reviewDate = new Date(review.entry_date).toLocaleDateString(
          "en-US",
          {
            day: "numeric",
            month: "short",
            year: "numeric",
          },
        );

        return (
          review.name_user.toLowerCase().includes(query) || // Match name
          review.msg.toLowerCase().includes(query) || // Match review content
          reviewDate.toLowerCase().includes(query) // Match formatted date
        );
      });
      setfilteredReviewsList(filterData);
    } else {
      setfilteredReviewsList([]);
    }
  };

  const [selectedReviewsid, setSelectedReviewsid] = useState([]);
  const [selectedArchieves, setSelectedArchieves] = useState([]);
  const [selectedFav, setSelectedFav] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);

  const handleSelectAll = () => {
    let allBbIds;
    let allArchieves;
    let allFav;
    if (isSelectAll) {
      setSelectedReviewsid([]);
      setIsSelectAll(false);
    } else {
      if (activeTab === "inbox") {
        allBbIds = reviews.map((review) => review.bb_id);
        allArchieves = reviews.map((review) => review.archives);
        allFav = reviews.map((review) => review.favorite);
      } else if (activeTab === "archieves") {
        allBbIds = archiveReviews.map((review) => review.bb_id);
        allArchieves = archiveReviews.map((review) => review.archives);
        allFav = archiveReviews.map((review) => review.favorite);
      } else if (activeTab === "replied") {
        allBbIds = repliedReviews.map((review) => review.bb_id);
        allArchieves = repliedReviews.map((review) => review.archives);
        allFav = repliedReviews.map((review) => review.favorite);
      } else if (activeTab === "starred") {
        allBbIds = starredReviews.map((review) => review.bb_id);
        allArchieves = starredReviews.map((review) => review.archives);
        allFav = starredReviews.map((review) => review.favorite);
      } else if (activeTab === "google") {
        allBbIds = googleReviews.map((review) => review.bb_id);
        allArchieves = googleReviews.map((review) => review.archives);
        allFav = googleReviews.map((review) => review.favorite);
      } else if (activeTab === "facebook") {
        allBbIds = facebookReviews.map((review) => review.bb_id);
        allArchieves = facebookReviews.map((review) => review.archives);
        allFav = facebookReviews.map((review) => review.favorite);
      } else if (activeTab === "playstore") {
        allBbIds = playstorereviews.map((review) => review.bb_id);
        allArchieves = playstorereviews.map((review) => review.archives);
        allFav = playstorereviews.map((review) => review.favorite);
      } else if (activeTab === "wowreview") {
        allBbIds = wowReviews.map((review) => review.bb_id);
        allArchieves = wowReviews.map((review) => review.archives);
        allFav = wowReviews.map((review) => review.favorite);
      }

      setSelectedReviewsid(allBbIds);
      setSelectedArchieves(allArchieves);
      setSelectedFav(allFav);
      setIsSelectAll(true);
    }
  };

  // Handle individual checkbox
  const handleCheckboxChange = (bb_id, archives, favorite) => {
    // Update bb_id state
    if (
      selectedReviewsid.includes(bb_id) &&
      selectedArchieves.includes(archives) &&
      selectedFav.includes(favorite)
    ) {
      setSelectedReviewsid(selectedReviewsid.filter((id) => id !== bb_id));
      setSelectedArchieves(
        selectedArchieves.filter((item) => item !== archives),
      );
      setSelectedFav(selectedFav.filter((item) => item !== favorite));
    } else {
      setSelectedReviewsid([...selectedReviewsid, bb_id]);
      setSelectedArchieves([...selectedArchieves, archives]);
      setSelectedFav([...selectedFav, favorite]);
    }
  };

  const master_update_multiple_favs = async (ids, favs, multi) => {
    setShowLoaderAdmin(true);
    const fd_from = new FormData();

    // Join IDs and favorite statuses with ~@~
    const idsJoined = ids.join("~");
    const favsJoined = favs.map((fav) => (fav == "0" ? "1" : "1")).join("~");

    fd_from.append("ticket_ids", idsJoined); // Pass joined IDs
    fd_from.append("favorites", favsJoined); // Pass joined favorites
    fd_from.append("multi", multi); // Indicate batch update (1 = multiple)

    await server_post_data(custom_favorite_reviews, fd_from)
      .then((Response) => {
        setShowLoaderAdmin(false);
        const data1 = Response.message.split("~@~");
        if (Number.parseInt(data1[0]) === 1) {
          handleError(data1[1]);
        } else {
          master_data_get(start, end, periodSelected); // Refresh data
          setSelectedReviewsid([]);
          setSelectedArchieves([]);
          setSelectedFav([]);
          setIsSelectAll(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setShowLoaderAdmin(false);
      });
  };

  const master_update_multiple_un_favs = async (ids, favs, multi) => {
    setShowLoaderAdmin(true);
    const fd_from = new FormData();

    // Join IDs and favorite statuses with ~@~
    const idsJoined = ids.join("~");
    const favsJoined = favs.map((fav) => (fav == "1" ? "0" : "0")).join("~");

    fd_from.append("ticket_ids", idsJoined); // Pass joined IDs
    fd_from.append("favorites", favsJoined); // Pass joined favorites
    fd_from.append("multi", multi); // Indicate batch update (1 = multiple)

    await server_post_data(custom_favorite_reviews, fd_from)
      .then((Response) => {
        setShowLoaderAdmin(false);
        const data1 = Response.message.split("~@~");
        if (Number.parseInt(data1[0]) === 1) {
          handleError(data1[1]);
        } else {
          master_data_get(start, end, periodSelected); // Refresh data
          setSelectedReviewsid([]);
          setSelectedArchieves([]);
          setSelectedFav([]);
          setIsSelectAll(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setShowLoaderAdmin(false);
      });
  };

  const master_update_archive_multi = async (id, fav, multi) => {
    setShowLoaderAdmin(true);
    const fd_from = new FormData();
    const idsJoined = id.join("~");
    const favsJoined = fav.map((fav) => (fav == "0" ? "1" : "1")).join("~");
    fd_from.append("ticket_ids", idsJoined);
    fd_from.append("favorites", favsJoined);
    fd_from.append("multi", multi); // 0 single & 1 loop
    await server_post_data(custom_update_archives_reviews, fd_from)
      .then((Response) => {
        setShowLoaderAdmin(false);
        const data1 = Response.message.split("~@~");
        if (Number.parseInt(data1[0]) === 1) {
          handleError(data1[1]);
        } else {
          master_data_get(start, end, periodSelected);
          setSelectedReviewsid([]);
          setSelectedArchieves([]);
          setSelectedFav([]);
          setIsSelectAll(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setShowLoaderAdmin(false);
      });
  };

  const master_update_archive_un_multi = async (id, fav, multi) => {
    setShowLoaderAdmin(true);
    const fd_from = new FormData();
    const idsJoined = id.join("~");
    const favsJoined = fav.map((fav) => (fav == "1" ? "0" : "0")).join("~");
    fd_from.append("ticket_ids", idsJoined);
    fd_from.append("favorites", favsJoined);
    fd_from.append("multi", multi); // 0 single & 1 loop
    await server_post_data(custom_update_archives_reviews, fd_from)
      .then((Response) => {
        setShowLoaderAdmin(false);
        const data1 = Response.message.split("~@~");
        if (Number.parseInt(data1[0]) === 1) {
          handleError(data1[1]);
        } else {
          master_data_get(start, end, periodSelected);
          setSelectedReviewsid([]);
          setSelectedArchieves([]);
          setSelectedFav([]);
          setIsSelectAll(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setShowLoaderAdmin(false);
      });
  };
  //// perosnal ai reply State and function
  const [showPersonalAi, setshowPersonalAi] = useState(false);
  const handleShowPersonalAi = () => {
    setshowPersonalAi(!showPersonalAi);
  };
  // console.log(replyTextShow);

  const [prompts, setPrompts] = useState([]);
  const [inputText, setInputText] = useState("");
  const [hasGenerated, setHasGenerated] = useState(false);
  useEffect(() => {
    const savedPrompts = JSON.parse(localStorage.getItem("prompts")) || [];
    setPrompts(savedPrompts);
  }, []);
  useEffect(() => {
    localStorage.setItem("prompts", JSON.stringify(prompts));
  }, [prompts]);

  const handleGenerateResponse = () => {
    if (inputText.trim()) {
      const newPrompt = {
        text: inputText,
        date: new Date().toLocaleString(),
      };
      setPrompts([newPrompt, ...prompts]);
      setInputText("");
      setHasGenerated(true);
      generate_reply(inputText.trim());
    }
  };

  const handleSelectPrompt = (text) => {
    setInputText(text);
  };

  const handleDeletePrompt = (index) => {
    const updatedPrompts = prompts.filter((_, i) => i !== index);
    setPrompts(updatedPrompts);
  };

  const clearError = () => {
    setErrorMessage(null);
  };

  const handleReconnect = () => {
    navigate("/Setup-Review-Channels", { state: { scrollToBottom: true } });
  };

  return (
    <>
      {ShowLoaderAdmin && <Loader />}
      <MasterLayout>
        {/* Breadcrumb */}
        <div style={{ overflowY: "hidden", height: "calc(100vh - 131px)" }}>
          <Breadcrumb title="Reviews" onDateSelection={handleDateSelection} />

          {/* Reviews Section */}
          <div style={{ overflowY: "hidden", height: "calc(100vh - 229px)" }}>
            <div className="row gy-4 flx_row_clsss m-0">
              <div className="col-xxl-2 col-md-3 d-md-block d-none mt-0 paddingAdjustLeft">
                <div
                  className="card p-0"
                  style={{ overflowY: "scroll", height: "calc(100vh - 235px)" }}
                >
                  <div className="card-body p-16">
                    <div>
                      <ul>
                        <li
                          className={`mb-4 ${
                            activeTab === "inbox" && "item-active"
                          }`}
                          onClick={() => handleTabChange("inbox")}
                        >
                          <Link className="bg-hover-primary-50 px-12 py-8 w-100 radius-8 text-secondary-light">
                            <span className="d-flex align-items-center gap-10 justify-content-between w-100">
                              <span className="d-flex align-items-center gap-10">
                                <span className="icon text-lg line-height-1 d-flex">
                                  <Icon
                                    icon="uil:envelope"
                                    className="icon line-height-1"
                                  />
                                </span>
                                <span className="fw-semibold text-sm">
                                  Inbox
                                </span>
                              </span>
                              <span className="fw-medium text-sm">
                                {inboxCount}
                              </span>
                            </span>
                          </Link>
                        </li>
                        <li
                          className={`mb-4 ${
                            activeTab === "starred" && "item-active"
                          }`}
                          onClick={() => handleTabChange("starred")}
                        >
                          <Link className="bg-hover-primary-50 px-12 py-8 w-100 radius-8 text-secondary-light">
                            <span className="d-flex align-items-center gap-10 justify-content-between w-100">
                              <span className="d-flex align-items-center gap-10">
                                <span className="icon text-lg line-height-1 d-flex">
                                  <Icon
                                    icon="ph:star-bold"
                                    className="icon line-height-1"
                                  />
                                </span>
                                <span className="fw-semibold text-sm">
                                  Starred
                                </span>
                              </span>
                              <span className="fw-medium text-sm">
                                {starsCount}
                              </span>
                            </span>
                          </Link>
                        </li>
                        <li
                          className={`mb-4 ${
                            activeTab === "replied" && "item-active"
                          }`}
                          onClick={() => handleTabChange("replied")}
                        >
                          <Link className="bg-hover-primary-50 px-12 py-8 w-100 radius-8 text-secondary-light">
                            <span className="d-flex align-items-center gap-10 justify-content-between w-100">
                              <span className="d-flex align-items-center gap-10">
                                <span className="icon text-lg line-height-1 d-flex">
                                  <Icon
                                    icon="ion:paper-plane-outline"
                                    className="icon line-height-1"
                                  />
                                </span>
                                <span className="fw-semibold text-sm">
                                  Replied
                                </span>
                              </span>
                              <span className="fw-medium text-sm">
                                {replyCount}
                              </span>
                            </span>
                          </Link>
                        </li>
                        <li
                          className={`mb-4 ${
                            activeTab === "unreplied" && "item-active"
                          }`}
                          onClick={() => handleTabChange("unreplied")}
                        >
                          <Link className="bg-hover-primary-50 px-12 py-8 w-100 radius-8 text-secondary-light">
                            <span className="d-flex align-items-center gap-10 justify-content-between w-100">
                              <span className="d-flex align-items-center gap-10">
                                <span className="icon text-lg line-height-1 d-flex">
                                  <Icon
                                    icon="mdi:email-alert-outline"
                                    className="icon line-height-1"
                                  />
                                </span>
                                <span className="fw-semibold text-sm">
                                  Unreplied
                                </span>
                              </span>
                              <span className="fw-medium text-sm">
                                {unrepliedCount}
                              </span>
                            </span>
                          </Link>
                        </li>
                        <li
                          className={`mb-4 ${
                            activeTab === "archieves" && "item-active"
                          }`}
                          onClick={() => handleTabChange("archieves")}
                        >
                          <Link className="bg-hover-primary-50 px-12 py-8 w-100 radius-8 text-secondary-light">
                            <span className="d-flex align-items-center gap-10 justify-content-between w-100">
                              <span className="d-flex align-items-center gap-10">
                                <span className="icon text-lg line-height-1 d-flex">
                                  <Icon
                                    icon="lucide:archive"
                                    className="icon line-height-1"
                                  />
                                </span>
                                <span className="fw-semibold text-sm">
                                  Archives
                                </span>
                              </span>
                              <span className="fw-medium text-sm">
                                {archiveCount}
                              </span>
                            </span>
                          </Link>
                        </li>
                      </ul>
                      <div className="mt-24">
                        <h6 className="text-lg fw-semibold text-primary-light mb-16">
                          Labels
                        </h6>
                        <ul>
                          <li
                            className="mb-20"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleTabChange("positive")}
                          >
                            <span className="line-height-1 fw-medium text-secondary-light text-sm d-flex align-items-center gap-10">
                              <span className="w-8-px h-8-px bg-cyan rounded-circle" />
                              Positive
                            </span>
                          </li>
                          <li
                            className="mb-20"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleTabChange("negative")}
                          >
                            <span className="line-height-1 fw-medium text-secondary-light text-sm d-flex align-items-center gap-10">
                              <span className="w-8-px h-8-px bg-yellow rounded-circle" />
                              Negative
                            </span>
                          </li>
                          <li
                            className="mb-20"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleTabChange("google")}
                          >
                            <span className="line-height-1 fw-medium text-secondary-light text-sm d-flex align-items-center gap-10">
                              <span className="w-8-px h-8-px bg-danger-hover rounded-circle" />
                              Google
                            </span>
                          </li>
                          <li
                            className="mb-20"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleTabChange("facebook")}
                          >
                            <span className="line-height-1 fw-medium text-secondary-light text-sm d-flex align-items-center gap-10">
                              <span className="w-8-px h-8-px bg-facebook rounded-circle" />
                              Facebook
                            </span>
                          </li>
                          <li
                            className="mb-20"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleTabChange("playstore")}
                          >
                            <span className="line-height-1 fw-medium text-secondary-light text-sm d-flex align-items-center gap-10">
                              <span className="w-8-px h-8-px bg-playstore rounded-circle" />
                              Play Store
                            </span>
                          </li>
                          <li
                            className="mb-20"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleTabChange("wowreview")}
                          >
                            <span className="line-height-1 fw-medium text-secondary-light text-sm d-flex align-items-center gap-10">
                              <span className="w-8-px h-8-px bg-danger-main rounded-circle" />
                              Wowreviews
                            </span>
                          </li>
                          <li
                            className="mb-20"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleTabChange("tripadvisor")}
                          >
                            <span className="line-height-1 fw-medium text-secondary-light text-sm d-flex align-items-center gap-10">
                              <span className="w-8-px h-8-px bg-tripadvisor rounded-circle" />
                              Tripadvisor
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {reviewOpen === null && (
                <div className="col-xxl-10 col-md-9 mt-0 paddingLeft0768 paddingAdjustRight">
                  <div
                    className="card h-100 p-0 email-card"
                    style={{
                      overflowY: "hidden",
                      height: "calc(100vh - 235px)",
                    }}
                  >
                    <div className="card-header border-bottom bg-base py-16 px-24">
                      <div className="d-flex flex-wrap align-items-center justify-content-between gap-4">
                        <div className="d-flex align-items-center gap-3">
                          <div className="form-check style-check d-flex align-items-center d-md-flex d-none">
                            <input
                              className="form-check-input radius-4 border input-form-dark"
                              type="checkbox"
                              name="selectAll"
                              id="selectAll"
                              checked={isSelectAll}
                              onChange={handleSelectAll}
                            />
                            <div className="dropdown line-height-1">
                              <button
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="line-height-1 d-flex"
                              >
                                <Icon
                                  icon="typcn:arrow-sorted-down"
                                  className="icon line-height-1"
                                />
                              </button>
                              <ul className="dropdown-menu p-12 border bg-base shadow">
                                <li>
                                  <button
                                    type="button"
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    onClick={() =>
                                      master_update_multiple_favs(
                                        selectedReviewsid,
                                        selectedFav,
                                        1,
                                      )
                                    }
                                  >
                                    Star
                                  </button>
                                </li>
                                <li>
                                  <button
                                    type="button"
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    onClick={() =>
                                      master_update_multiple_un_favs(
                                        selectedReviewsid,
                                        selectedFav,
                                        1,
                                      )
                                    }
                                  >
                                    Unstar
                                  </button>
                                </li>
                                <li>
                                  <button
                                    type="button"
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    onClick={() =>
                                      master_update_archive_multi(
                                        selectedReviewsid,
                                        selectedArchieves,
                                        1,
                                      )
                                    }
                                  >
                                    Archive
                                  </button>
                                </li>
                                <li>
                                  <button
                                    type="button"
                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                    onClick={() =>
                                      master_update_archive_un_multi(
                                        selectedReviewsid,
                                        selectedArchieves,
                                        1,
                                      )
                                    }
                                  >
                                    UnArchive
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="delete-button d-none text-secondary-light text-xl d-flex"
                          >
                            <Icon
                              icon="material-symbols:delete-outline"
                              className="icon line-height-1"
                            />
                          </button>
                          <button
                            type="button"
                            className="reload-button text-secondary-light text-xl d-flex d-md-flex d-none"
                          >
                            <Icon icon="tabler:reload" className="icon" />
                          </button>
                          <div className="dropdown line-height-1 d-md-none">
                            <button
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              className="line-height-1 d-flex"
                            >
                              <Icon
                                icon="heroicons:bars-3-solid"
                                className="icon text-2xl non-active "
                              />
                            </button>
                            <ul className="dropdown-menu p-12 border bg-base shadow">
                              <li onClick={() => handleTabChange("inbox")}>
                                <button
                                  type="button"
                                  className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                >
                                  <span className="d-flex align-items-center gap-10">
                                    <span className="icon text-lg line-height-1 d-flex">
                                      <Icon
                                        icon="uil:envelope"
                                        className="icon line-height-1"
                                      />
                                    </span>
                                    <span className="fw-semibold text-sm">
                                      Inbox
                                    </span>
                                  </span>
                                </button>
                              </li>
                              <li onClick={() => handleTabChange("starred")}>
                                <button
                                  type="button"
                                  className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                >
                                  <span className="d-flex align-items-center gap-10">
                                    <span className="icon text-lg line-height-1 d-flex">
                                      <Icon
                                        icon="ph:star-bold"
                                        className="icon line-height-1"
                                      />
                                    </span>
                                    <span className="fw-semibold text-sm">
                                      Starred
                                    </span>
                                  </span>
                                </button>
                              </li>
                              <li onClick={() => handleTabChange("replied")}>
                                <button
                                  type="button"
                                  className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                >
                                  <span className="d-flex align-items-center gap-10">
                                    <span className="icon text-lg line-height-1 d-flex">
                                      <Icon
                                        icon="ion:paper-plane-outline"
                                        className="icon line-height-1"
                                      />
                                    </span>
                                    <span className="fw-semibold text-sm">
                                      Replied
                                    </span>
                                  </span>
                                </button>
                              </li>
                              {/* FIX: was handleTabChange("archives") which never matched
                                  the "archieves" tab used everywhere else */}
                              <li onClick={() => handleTabChange("archieves")}>
                                <button
                                  type="button"
                                  className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                >
                                  <span className="d-flex align-items-center gap-10">
                                    <span className="icon text-lg line-height-1 d-flex">
                                      <Icon
                                        icon="lucide:pencil"
                                        className="icon line-height-1"
                                      />
                                    </span>
                                    <span className="fw-semibold text-sm">
                                      Archives
                                    </span>
                                  </span>
                                </button>
                              </li>
                            </ul>
                          </div>
                          {/* <form className="navbar-search d-lg-block d-none"> */}
                          <form className="navbar-search d-block">
                            <input
                              type="text"
                              className="bg-base h-40-px w-auto"
                              name="search"
                              placeholder="Search"
                              defaultValue={searchQuery}
                              onChange={(e) => {
                                setSearchQuery(e.target.value);
                                searchQueryFilter(e.target.value);
                              }}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                          </form>
                        </div>
                        <div className="d-flex align-items-center gap-3 d-md-block d-none">
                          <span className="text-secondary-light line-height-1">
                            {indexOfFirstReview + 1}-
                            {Math.min(
                              indexOfLastReview,
                              filteredReviews.length,
                            )}{" "}
                            of {filteredReviews.length}
                          </span>
                          <nav aria-label="Page navigation example">
                            <ul className="pagination">
                              <li
                                className={`page-item ${
                                  currentPage === 1 ? "disabled" : ""
                                }`}
                              >
                                <button
                                  className="page-link d-flex bg-base border text-secondary-light text-xl"
                                  onClick={handlePrevPage}
                                  disabled={currentPage === 1}
                                >
                                  <Icon
                                    icon="iconamoon:arrow-left-2"
                                    className="icon"
                                  />
                                </button>
                              </li>
                              <li
                                className={`page-item ${
                                  currentPage === totalPages ? "disabled" : ""
                                }`}
                              >
                                <button
                                  className="page-link d-flex bg-base border text-secondary-light text-xl"
                                  onClick={handleNextPage}
                                  disabled={currentPage === totalPages}
                                >
                                  <Icon
                                    icon="iconamoon:arrow-right-2"
                                    className="icon"
                                  />
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                    {errorMessage != null && (
                      <div
                        className="error-banner container-fluid my-2"
                        role="alert"
                        aria-live="assertive"
                      >
                        <div className="d-flex">
                          <button
                            className="close-btn d-flex align-items-center"
                            onClick={handleReconnect}
                            aria-label="Close error message"
                          >
                            <Icon
                              icon="mdi:sync"
                              className="text-primary-light text-xl"
                            />
                          </button>
                          <span>{errorMessage}</span>
                        </div>

                        <button
                          className="close-btn"
                          onClick={clearError}
                          aria-label="Close error message"
                        >
                          <Icon icon="mingcute:close-line" />
                        </button>
                      </div>
                    )}
                    {fbErrorMessage != null && (
                      <div
                        className="error-banner container-fluid  my-2"
                        role="alert"
                        aria-live="assertive"
                      >
                        <div className="d-flex">
                          <button
                            className="close-btn d-flex align-items-center"
                            onClick={handleReconnect}
                            aria-label="Close error message"
                          >
                            <Icon
                              icon="mdi:sync"
                              className="text-primary-light text-xl"
                            />
                          </button>
                          <span>{fbErrorMessage}</span>
                        </div>

                        <button
                          className="close-btn"
                          onClick={clearError}
                          aria-label="Close error message"
                        >
                          <Icon icon="mingcute:close-line" />
                        </button>
                      </div>
                    )}
                    <div
                      className="card-body p-0"
                      style={{
                        overflowY: "scroll",
                        height:
                          errorMessage != null
                            ? "calc(100vh - 443px)"
                            : fbErrorMessage != null
                              ? "calc(100vh - 443px)"
                              : "calc(100vh - 329px)",
                      }}
                    >
                      <ul className="overflow-x-auto d-md-block d-none">
                        {filteredReviewsList &&
                        filteredReviewsList.length > 0 ? (
                          <>
                            {filteredReviewsList &&
                              filteredReviewsList.length > 0 &&
                              filteredReviewsList.map((review) => (
                                <li
                                  key={review.bb_id}
                                  className={`email-item px-24 py-16 d-flex gap-3 align-items-center border-bottom cursor-pointer bg-hover-neutral-200 min-w-max-content`}
                                >
                                  <div className="form-check style-check d-flex align-items-center">
                                    <input
                                      className="form-check-input radius-4 border border-neutral-400"
                                      type="checkbox"
                                      name="checkbox"
                                    />
                                  </div>
                                  <button
                                    type="button"
                                    className="starred-button icon text-sm text-secondary-light line-height-1 d-flex"
                                    onClick={() =>
                                      master_update_fav(
                                        review.bb_id,
                                        review.favorite,
                                        0,
                                      )
                                    }
                                  >
                                    {review.favorite == "0" ? (
                                      <Icon
                                        icon="ph:star"
                                        className="icon-outline line-height-1"
                                      />
                                    ) : (
                                      <Icon
                                        icon="ph:star-fill"
                                        className="icon-outline line-height-1 text-warning-600"
                                      />
                                    )}
                                  </button>
                                  {/* Platform info */}
                                  <span
                                    className="text-secondary-light fw-bold text-sm ms-4"
                                    onClick={() =>
                                      handleReviewOpen(
                                        review.bb_id,
                                        review.platform,
                                      )
                                    }
                                  >
                                    {review.platform === "Facebook" && (
                                      <img
                                        className="w-28-px h-28-px"
                                        src="assets/images/FacebookNew.png"
                                        alt="WOW Reviews"
                                      />
                                    )}
                                    {review.platform === "Google" && (
                                      <img
                                        className="w-28-px h-28-px"
                                        src="assets/images/googleNew.png"
                                        alt="WOW Reviews"
                                      />
                                    )}
                                    {review.platform === "WowReview" && (
                                      <img
                                        className="w-28-px h-28-px"
                                        src="assets/images/wowo.png"
                                        alt="WOW Reviews"
                                      />
                                    )}
                                    {review.platform ===
                                      "Android Play Store" && (
                                      <img
                                        className="w-28-px h-28-px"
                                        src="assets/images/playstore.png"
                                        alt="WOW Reviews"
                                      />
                                    )}
                                    {review.platform === "Tripadvisor" && (
                                      <img
                                        className="w-28-px h-28-px"
                                        src="assets/images/TripAdvisor.png"
                                        alt="WOW Reviews"
                                      />
                                    )}
                                  </span>
                                  <Link
                                    className={`${
                                      review.open_close == "1"
                                        ? "opennedReview"
                                        : ""
                                    } text-primary-light text-sm fw-medium text-sm text-line-1 w-100-px`}
                                    onClick={() =>
                                      handleReviewOpen(
                                        review.bb_id,
                                        review.platform,
                                      )
                                    }
                                  >
                                    {review.name_user}
                                  </Link>
                                  <Link
                                    className={`${
                                      review.open_close == "1"
                                        ? "opennedReview msg_width"
                                        : ""
                                    } text-primary-light text-sm fw-medium mb-0 text-line-1 w-440-px msg_width`}
                                    onClick={() =>
                                      handleReviewOpen(
                                        review.bb_id,
                                        review.platform,
                                      )
                                    }
                                  >
                                    {review.msg && review.msg.length > 0 ? (
                                      review.msg
                                    ) : (
                                      <p className="noresponseTag">
                                        No Response
                                      </p>
                                    )}
                                  </Link>
                                  {/* <Link
                                  className={`${
                                    review.open_close == "1"
                                      ? "opennedReview"
                                      : ""
                                  } mb-0 text-line-1`}
                                  onClick={() => handleReviewOpen(review.bb_id,review.platform)}
                                >
                                  <StarRating rating={3} />
                                </Link> */}
                                  <Link
                                    className={` ${
                                      review.open_close == "1"
                                        ? "opennedReview"
                                        : ""
                                    } text-primary-light text-xs fw-medium min-w-max-content ms-auto`}
                                    onClick={() =>
                                      handleReviewOpen(
                                        review.bb_id,
                                        review.platform,
                                      )
                                    }
                                  >
                                    {formatReviewDate(review.entry_date)}
                                  </Link>
                                </li>
                              ))}
                          </>
                        ) : (
                          <>
                            {currentReviews &&
                              currentReviews.length > 0 &&
                              currentReviews.map((review) => (
                                <li
                                  key={review.bb_id}
                                  className={`email-item px-24 py-16 d-flex gap-3 align-items-center border-bottom cursor-pointer bg-hover-neutral-200 min-w-max-content`}
                                >
                                  <div className="form-check style-check d-flex align-items-center">
                                    <input
                                      className="form-check-input radius-4 border border-neutral-400"
                                      type="checkbox"
                                      name="checkbox"
                                      checked={selectedReviewsid.includes(
                                        review.bb_id,
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          review.bb_id,
                                          review.archives,
                                          review.favorite,
                                        )
                                      }
                                    />
                                  </div>
                                  <button
                                    type="button"
                                    className="starred-button icon text-sm text-secondary-light line-height-1 d-flex"
                                    onClick={() =>
                                      master_update_fav(
                                        review.bb_id,
                                        review.favorite,
                                        0,
                                      )
                                    }
                                  >
                                    {review.favorite == "0" ? (
                                      <Icon
                                        icon="ph:star"
                                        className="icon-outline line-height-1"
                                      />
                                    ) : (
                                      <Icon
                                        icon="ph:star-fill"
                                        className="icon-outline line-height-1 text-warning-600"
                                      />
                                    )}
                                  </button>
                                  {/* Platform info */}
                                  <span
                                    className="text-secondary-light fw-bold text-sm ms-4"
                                    onClick={() =>
                                      handleReviewOpen(
                                        review.bb_id,
                                        review.platform,
                                      )
                                    }
                                  >
                                    {review.platform === "Facebook" && (
                                      <img
                                        className="w-28-px h-28-px"
                                        src="assets/images/FacebookNew.png"
                                        alt="WOW Reviews"
                                      />
                                    )}
                                    {review.platform === "Google" && (
                                      <img
                                        className="w-28-px h-28-px"
                                        src="assets/images/googleNew.png"
                                        alt="WOW Reviews"
                                      />
                                    )}
                                    {review.platform === "WowReview" && (
                                      <img
                                        className="w-28-px h-28-px"
                                        src="assets/images/wowo.png"
                                        alt="WOW Reviews"
                                      />
                                    )}
                                    {review.platform ===
                                      "Android Play Store" && (
                                      <img
                                        className="w-28-px h-28-px"
                                        src="assets/images/playstore.png"
                                        alt="WOW Reviews"
                                      />
                                    )}
                                    {review.platform === "Tripadvisor" && (
                                      <img
                                        className="w-28-px h-28-px"
                                        src="assets/images/TripAdvisor.png"
                                        alt="WOW Reviews"
                                      />
                                    )}
                                  </span>
                                  <Link
                                    className={`${
                                      review.open_close == "1"
                                        ? "opennedReview"
                                        : ""
                                    } text-primary-light text-sm fw-medium text-sm text-line-1 w-100-px`}
                                    onClick={() =>
                                      handleReviewOpen(
                                        review.bb_id,
                                        review.platform,
                                      )
                                    }
                                  >
                                    {review.name_user}
                                  </Link>
                                  <Link
                                    className={`${
                                      review.open_close == "1"
                                        ? "opennedReview"
                                        : ""
                                    } text-primary-light text-sm fw-medium mb-0 text-line-1 w-200-px msg_width `}
                                    onClick={() =>
                                      handleReviewOpen(
                                        review.bb_id,
                                        review.platform,
                                      )
                                    }
                                  >
                                    {review.msg && review.msg.length > 0 ? (
                                      review.msg
                                    ) : (
                                      <p className="noresponseTag">
                                        No Response
                                      </p>
                                    )}
                                  </Link>
                                  {review.rating == 0 ||
                                  review.rating == " " ? (
                                    <Link
                                      className={`${
                                        review.open_close == "1"
                                          ? "opennedReview"
                                          : ""
                                      } text-primary-light fw-medium mb-0 mx-auto text-line-1 w-200-px`}
                                      onClick={() =>
                                        handleReviewOpen(
                                          review.bb_id,
                                          review.platform,
                                        )
                                      }
                                    >
                                      <p
                                        className="noresponseTag"
                                        style={{
                                          fontSize: "12px",
                                          marginRight: "0",
                                        }}
                                      >
                                        No Ratings Provided
                                      </p>
                                    </Link>
                                  ) : (
                                    <Link
                                      className={`${
                                        review.open_close == "1"
                                          ? "opennedReview"
                                          : ""
                                      } mb-0 mx-auto text-line-1`}
                                      onClick={() =>
                                        handleReviewOpen(
                                          review.bb_id,
                                          review.platform,
                                        )
                                      }
                                    >
                                      <StarRating rating={review.rating} />
                                    </Link>
                                  )}
                                  <Link
                                    className={` ${
                                      review.open_close == "1"
                                        ? "opennedReview"
                                        : ""
                                    } text-primary-light text-xs fw-medium min-w-max-content ms-auto`}
                                    onClick={() =>
                                      handleReviewOpen(
                                        review.bb_id,
                                        review.platform,
                                      )
                                    }
                                    style={{
                                      width: "55px",
                                      textAlign: "right",
                                    }}
                                  >
                                    {formatReviewDate(review.entry_date)}
                                  </Link>
                                </li>
                              ))}
                          </>
                        )}
                      </ul>
                      <ul className="overflow-x-auto d-md-none">
                        {filteredReviews &&
                          filteredReviews.length > 0 &&
                          filteredReviews.map((review) => (
                            <li
                              key={review.bb_id}
                              className="email-item px-16 py-12 d-flex gap-3 align-items-center justify-content-between border-bottom cursor-pointer bg-hover-neutral-200 min-w-max-content"
                            >
                              {/* Platform info */}
                              <div className="d-flex gap-3 align-items-center">
                                <span
                                  className="text-secondary-light fw-bold text-sm ms-4"
                                  onClick={() =>
                                    handleReviewOpen(
                                      review.bb_id,
                                      review.platform,
                                    )
                                  }
                                >
                                  {review.platform === "Facebook" && (
                                    <img
                                      className="w-36-px h-36-px"
                                      src="assets/images/FacebookNew.png"
                                      alt="WOW Reviews"
                                    />
                                  )}
                                  {review.platform === "Google" && (
                                    <img
                                      className="w-36-px h-36-px"
                                      src="assets/images/googleNew.png"
                                      alt="WOW Reviews"
                                    />
                                  )}
                                  {review.platform === "WowReview" && (
                                    <img
                                      className="w-28-px h-28-px"
                                      src="assets/images/wowo.png"
                                      alt="WOW Reviews"
                                    />
                                  )}
                                  {review.platform === "Android Play Store" && (
                                    <img
                                      className="w-28-px h-28-px"
                                      src="assets/images/playstore.png"
                                      alt="WOW Reviews"
                                    />
                                  )}
                                  {review.platform === "Tripadvisor" && (
                                    <img
                                      className="w-28-px h-28-px"
                                      src="assets/images/TripAdvisor.png"
                                      alt="WOW Reviews"
                                    />
                                  )}
                                </span>
                                <div
                                  className={`${
                                    review.open_close == "1"
                                      ? "opennedReview"
                                      : ""
                                  }`}
                                >
                                  <Link
                                    className="text-primary-light text-sm fw-medium text-sm text-line-1 w-100-px"
                                    onClick={() =>
                                      handleReviewOpen(
                                        review.bb_id,
                                        review.platform,
                                      )
                                    }
                                  >
                                    {review.name_user}
                                  </Link>
                                  <Link
                                    className="text-primary-light text-sm fw-medium mb-0 text-line-1 w-440-px msg_width "
                                    onClick={() =>
                                      handleReviewOpen(
                                        review.bb_id,
                                        review.platform,
                                      )
                                    }
                                  >
                                    {review.msg && review.msg.length > 0 ? (
                                      review.msg
                                    ) : (
                                      <p className="noresponseTag">
                                        No Response
                                      </p>
                                    )}
                                  </Link>
                                </div>
                              </div>
                              <div className="d-flex flex-column align-items-end">
                                <span
                                  className={` ${
                                    review.open_close == "1"
                                      ? "opennedReview"
                                      : ""
                                  } text-primary-light text-xs fw-medium min-w-max-content ms-auto`}
                                >
                                  {formatReviewDate(review.entry_date)}
                                </span>
                                <button
                                  type="button"
                                  className="starred-button icon text-lg text-secondary-light line-height-1 d-flex"
                                  onClick={() =>
                                    master_update_fav(
                                      review.bb_id,
                                      review.favorite,
                                      0,
                                    )
                                  }
                                >
                                  {review.favorite == "0" ? (
                                    <Icon
                                      icon="ph:star"
                                      className="icon-outline line-height-1"
                                    />
                                  ) : (
                                    <Icon
                                      icon="ph:star-fill"
                                      className="icon-outline line-height-1 text-warning-600"
                                    />
                                  )}
                                </button>
                              </div>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                </div>
              )}
              {reviewOpen != null && (
                <>
                  {reviewSelected && (
                    <>
                      <div
                        className={`paddingLeft0768 mt-0 ${
                          showPersonalAi
                            ? "col-xxl-7 col-md-9 col-lg-6 "
                            : "col-xxl-10 col-md-9 col-lg-9"
                        }`}
                        style={{ height: "calc(100vh - 235px)" }}
                      >
                        <div
                          className="card h-100 p-0 email-card overflow-x-auto d-block"
                          style={{ height: "100%" }}
                        >
                          <div
                            className="min-w-300-px d-flex flex-column"
                            style={{ height: "100%", overflow: "hidden" }}
                          >
                            <div
                              className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center gap-3 justify-content-between flex-wrap"
                              style={{ flexShrink: 0 }}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className="text-secondary-light d-flex me-8"
                                  onClick={handleReviewClose}
                                >
                                  <Icon
                                    icon="mingcute:arrow-left-line"
                                    className="icon fs-3 line-height-1"
                                  />
                                </button>
                                <h6 className="mb-0 text-lg">
                                  {reviewSelected.name_user}
                                </h6>
                                <span className="bg-primary-50 text-primary-600 text-sm radius-4 px-8">
                                  {reviewSelected.platform}
                                </span>
                              </div>
                              <div className="d-flex align-items-center gap-3">
                                <button
                                  className="text-secondary-light d-flex"
                                  onClick={() =>
                                    master_update_fav(
                                      reviewSelected.bb_id,
                                      reviewSelected.favorite,
                                      0,
                                    )
                                  }
                                >
                                  {reviewSelected.favorite == "0" ? (
                                    <Icon
                                      icon="ph:star"
                                      className="icon-outline text-xxl line-height-1"
                                    />
                                  ) : (
                                    <Icon
                                      icon="ph:star-fill"
                                      className="icon-outline text-xxl line-height-1 text-warning-600"
                                    />
                                  )}
                                </button>
                                <button
                                  className="text-secondary-light d-flex"
                                  onClick={() => {
                                    master_update_archive(
                                      reviewSelected.bb_id,
                                      reviewSelected.archives,
                                      0,
                                    );
                                  }}
                                >
                                  {reviewSelected.archives == "0" ? (
                                    <Icon
                                      icon="material-symbols:archive-outline"
                                      className="icon text-xxl line-height-1"
                                    />
                                  ) : (
                                    <Icon
                                      icon="material-symbols:archive"
                                      className="icon text-xxl line-height-1"
                                    />
                                  )}
                                </button>
                              </div>
                            </div>
                            <div
                              className="card-body p-0"
                              style={{
                                flex: "1 1 auto",
                                overflowY: "auto",
                                minHeight: 0,
                              }}
                            >
                              <div className="py-16 px-24 border-bottom">
                                <div className="d-flex align-items-start gap-3 justify-content-between">
                                  <div className="d-flex align-items-start  gap-3">
                                    <span className="w-40-px h-40-px bg-info-subtle text-info-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                                      {getInitials(reviewSelected?.name_user)}
                                    </span>
                                    <div className="">
                                      <div className="d-flex align-items-center flex-wrap gap-2">
                                        <h6 className="mb-0 text-lg">
                                          {reviewSelected.name_user}
                                        </h6>
                                        <span className="text-secondary-light text-xs">
                                          {formatReviewDate(
                                            reviewSelected.entry_date,
                                          )}
                                        </span>
                                      </div>
                                      <div className="mt-10">
                                        <p
                                          className="mb-10 text-primary-light"
                                          style={{ fontSize: "13px" }}
                                        >
                                          {reviewSelected.msg &&
                                          reviewSelected.msg.length > 0 ? (
                                            <>
                                              <div className="d-flex align-items-center flex-wrap">
                                                {reviewSelected.answer_1 &&
                                                  reviewSelected.answer_1
                                                    .length > 0 && (
                                                    <span
                                                      className="py-1"
                                                      style={{
                                                        marginRight: "1rem",
                                                      }}
                                                    >
                                                      Overall Experience:{" "}
                                                      <span
                                                        style={{
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        {
                                                          reviewSelected.answer_1
                                                        }
                                                        /5
                                                      </span>
                                                    </span>
                                                  )}
                                                {reviewSelected.answer_2 &&
                                                  reviewSelected.answer_2
                                                    .length > 0 && (
                                                    <span
                                                      className="py-1"
                                                      style={{
                                                        marginRight: "1rem",
                                                      }}
                                                    >
                                                      Rental Process:{" "}
                                                      <span
                                                        style={{
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        {
                                                          reviewSelected.answer_2
                                                        }
                                                        /5
                                                      </span>
                                                    </span>
                                                  )}
                                                {reviewSelected.answer_3 &&
                                                  reviewSelected.answer_3
                                                    .length > 0 && (
                                                    <span
                                                      className="py-1"
                                                      style={{
                                                        marginRight: "1rem",
                                                      }}
                                                    >
                                                      Car Condition:{" "}
                                                      <span
                                                        style={{
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        {
                                                          reviewSelected.answer_3
                                                        }
                                                        /5
                                                      </span>
                                                    </span>
                                                  )}
                                                {reviewSelected.answer_4 &&
                                                  reviewSelected.answer_4
                                                    .length > 0 && (
                                                    <span
                                                      className="py-1"
                                                      style={{
                                                        marginRight: "1rem",
                                                      }}
                                                    >
                                                      Maintanance Process:{" "}
                                                      <span
                                                        style={{
                                                          fontWeight: "600",
                                                        }}
                                                      >
                                                        {
                                                          reviewSelected.answer_4
                                                        }
                                                        /5
                                                      </span>
                                                    </span>
                                                  )}
                                              </div>
                                              {reviewSelected.msg}
                                            </>
                                          ) : (
                                            <p className="noresponseTag">
                                              No Response
                                            </p>
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  {reviewSelected.rating != 0 && (
                                    <div className="review_div">
                                      <StarRating
                                        rating={reviewSelected.rating}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                              {replyTextState ? (
                                <>
                                  {reviewSelected.reply != "" &&
                                    reviewSelected.platform != "WowReview" && (
                                      <div className="py-16 px-24 border-bottom">
                                        <div className="d-flex align-items-start gap-3">
                                          <span className="w-40-px h-40-px bg-info-subtle text-info-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                                            {getInitials(adminName)}
                                          </span>
                                          <div className="">
                                            <div className="d-flex align-items-center flex-wrap gap-2">
                                              <h6 className="mb-0 text-lg">
                                                {adminName}
                                              </h6>
                                              {/* <span className="text-secondary-light text-xs">
                                {formatReviewDate(
                                  reviewSelected.entry_date
                                )}
                              </span> */}
                                            </div>
                                            <div>
                                              <p className="mb-0 text-primary-light">
                                                {reviewSelected.reply}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                </>
                              ) : (
                                <>
                                  {!replyDone && (
                                    <>
                                      {replyTextShow != "" &&
                                        reviewSelected.platform !=
                                          "WowReview" && (
                                          <div className="py-16 px-24 border-bottom">
                                            <div className="d-flex align-items-start gap-3">
                                              <span className="w-40-px h-40-px bg-info-subtle text-info-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                                                {getInitials(adminName)}
                                              </span>
                                              <div className="">
                                                <div className="d-flex align-items-center flex-wrap gap-2">
                                                  <h6 className="mb-0 text-lg">
                                                    {adminName}
                                                  </h6>
                                                  {/* <span className="text-secondary-light text-xs">
                                {formatReviewDate(
                                  reviewSelected.entry_date
                                )}
                              </span> */}
                                                </div>
                                                <div>
                                                  <p className="mb-0 text-primary-light">
                                                    {replyTextShow}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </>
                                  )}
                                </>
                              )}
                              {replyDone && (
                                <div className="py-16 px-24">
                                  <div className="d-flex align-items-start gap-3">
                                    <span className="w-40-px h-40-px bg-info-subtle text-info-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                                      {getInitials(adminName)}
                                    </span>
                                    <div className="w-100">
                                      <div className="d-flex align-items-center flex-wrap gap-2">
                                        <h6 className="mb-0 text-lg">
                                          {adminName}
                                        </h6>
                                        {/* <span className="text-secondary-light text-xs">
                                {formatReviewDate(
                                  reviewSelected.entry_date
                                )}
                              </span> */}
                                      </div>
                                      {reviewSelected.platform !=
                                        "Tripadvisor" && (
                                        <div className="w-100 mt-10 textNoStyle">
                                          <textarea
                                            key={reviewSelected.bb_id}
                                            className="textarea-max-height form-control border-0 py-8 pe-16 resize-none scroll-sm min_hghtClsss"
                                            style={{
                                              paddingLeft: "0.5rem",
                                              minHeight: "80px", // 👈 NAYA — CSS class ka bada min-height override
                                              maxHeight: "120px", // 👈 NAYA — ab zyada bada nahi hoga
                                              overflowY: "auto", // 👈 agar user lamba text likhe to textarea khud scroll karega
                                            }}
                                            placeholder="Write message"
                                            onChange={handlereviewChange}
                                            defaultValue={
                                              replyText && replyText.length > 1
                                                ? replyText
                                                : ""
                                            }
                                            // autoFocus
                                            // readOnly={
                                            //   reviewSelected.msg === "" ||
                                            //   reviewSelected.reply_noreply == "1" ||
                                            //   replyTextShow != ""
                                            // }
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                            <div
                              className="card-footer py-16 px-24 bg-base shadow-top"
                              style={{
                                flexShrink: 0,
                                maxHeight: "45%", // 👈 footer ab card ki max 45% height tak hi jayega
                                overflowY: "auto", // 👈 agar content bada ho to yahi andar scroll karega
                              }}
                            >
                              <form action="#">
                                <div className="d-flex align-items-center justify-content-between">
                                  {reviewSelected.platform == "WowReview" && (
                                    <>
                                      <span>Contact Customer :</span>
                                      <div className="contactBtnsC">
                                        <button
                                          onClick={(e) => {
                                            e.preventDefault();
                                            const phoneNumber =
                                              reviewSelected?.contact_no;
                                            window.location.href = `tel:${phoneNumber}`;
                                          }}
                                        >
                                          <img
                                            src={Phone}
                                            alt="Call Customer"
                                          />
                                        </button>
                                        <button
                                          onClick={(e) => {
                                            e.preventDefault();
                                            const whatsappNumber =
                                              reviewSelected?.contact_no;
                                            const message =
                                              "Hello! I would like to get in touch.";
                                            const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
                                              message,
                                            )}`;
                                            window.open(whatsappUrl, "_blank");
                                          }}
                                        >
                                          <img
                                            src={whatsapp}
                                            alt="Whatsapp Customer"
                                          />
                                        </button>
                                        <button
                                          onClick={(e) => {
                                            e.preventDefault();
                                            const email = reviewSelected?.email;
                                            const subject = "Wowreviews";
                                            const body =
                                              "Hello, I would like to discuss something.";
                                            const emailUrl = `mailto:${email}?subject=${encodeURIComponent(
                                              subject,
                                            )}&body=${encodeURIComponent(
                                              body,
                                            )}`;
                                            window.open(emailUrl, "_blank");
                                          }}
                                        >
                                          <img
                                            src={Gmail}
                                            alt="Mail Customer"
                                          />
                                        </button>
                                      </div>
                                    </>
                                  )}
                                  <>
                                    {!replyDone && (
                                      <>
                                        {reviewSelected.platform !==
                                          "WowReview" &&
                                          hasReplyableContent(reviewSelected) &&
                                          reviewSelected.reply == "" && (
                                            <div className="w-100 mt-10 textareaNerw textNoStyle">
                                              {reviewSelected.platform !=
                                                "Tripadvisor" && (
                                                <textarea
                                                  key={reviewSelected.bb_id}
                                                  className=" textarea-max-height form-control border-0 py-8 pe-16 resize-none scroll-sm min_hghtClsss"
                                                  style={{
                                                    paddingLeft: "0rem",
                                                    marginTop: "0.5rem",
                                                    width: "100%",
                                                    fontSize: "12px",
                                                    minHeight: "80px",
                                                    maxHeight: "120px",
                                                    overflowY: "auto",
                                                  }}
                                                  placeholder="Write message"
                                                  onChange={handlereviewChange}
                                                  defaultValue={
                                                    replyText &&
                                                    replyText.length > 1
                                                      ? replyText
                                                      : ""
                                                  }
                                                  autoFocus
                                                />
                                              )}
                                            </div>
                                          )}
                                      </>
                                    )}

                                    <div className="d-flex align-items-center gap-4 ms-16 hidden">
                                      <div className="hidden">
                                        <label
                                          htmlFor="attatchment"
                                          className="text-secondary-light text-xl"
                                        >
                                          <Icon
                                            icon="octicon:link-16"
                                            className="icon line-height-1"
                                          />
                                        </label>
                                        <input
                                          type="file"
                                          id="attatchment"
                                          hidden={true}
                                        />
                                      </div>
                                      <div className="hidden">
                                        <label
                                          htmlFor="gallery"
                                          className="text-secondary-light text-xl"
                                        >
                                          <Icon
                                            icon="solar:gallery-bold"
                                            className="icon line-height-1"
                                          />
                                        </label>
                                        <input
                                          type="file"
                                          id="gallery"
                                          hidden={true}
                                        />
                                      </div>
                                    </div>
                                  </>
                                </div>
                              </form>
                              {reviewSelected.platform !== "WowReview" &&
                                hasReplyableContent(reviewSelected) &&
                                reviewSelected.reply === "" && (
                                  <>
                                    {!showTeaxtarea && (
                                      <div className="card_footer_ai_bttns">
                                        {reviewSelected.platform !=
                                        "Tripadvisor" ? (
                                          <>
                                            <div className="ai_bttns">
                                              <button
                                                type="button"
                                                className={`Personolized_ai_bttn ${
                                                  startAnimAI
                                                    ? "ai_button_animation"
                                                    : ""
                                                }`}
                                                onClick={() => {
                                                  generate_reply();
                                                }}
                                              >
                                                {" "}
                                                <AiOutlineRobot />
                                                Generate{" "}
                                                <span className="ai_rply_span">
                                                  <span className="aiTxt">
                                                    AI
                                                  </span>{" "}
                                                  Reply
                                                </span>
                                              </button>
                                              <button
                                                type="button"
                                                className="genrate_ai_btn"
                                                onClick={handleShowPersonalAi}
                                              >
                                                <AiOutlineRobot />
                                                Persolized{" "}
                                                <span className="ai_rply_span">
                                                  <span className="aiTxt">
                                                    AI
                                                  </span>{" "}
                                                  Reply
                                                </span>
                                              </button>
                                            </div>
                                            <div className="sndBttn">
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  const isGoogleDisabled =
                                                    reviewSelected.platform ===
                                                      "Google" &&
                                                    retrieveData(
                                                      "google_connect_stat",
                                                    ) === "1";
                                                  const isFacebookDisabled =
                                                    reviewSelected.platform ===
                                                      "Facebook" &&
                                                    retrieveData(
                                                      "facebook_connect_stat",
                                                    ) === "1";

                                                  if (
                                                    isGoogleDisabled ||
                                                    isFacebookDisabled
                                                  ) {
                                                    return null;
                                                  }

                                                  return submit_review_replay(
                                                    reviewSelected.bb_id,
                                                  );
                                                }}
                                                disabled={
                                                  (reviewSelected.platform ===
                                                    "Google" &&
                                                    retrieveData(
                                                      "google_connect_stat",
                                                    ) == "1") ||
                                                  (reviewSelected.platform ===
                                                    "Facebook" &&
                                                    retrieveData(
                                                      "facebook_connect_stat",
                                                    ) == "1")
                                                }
                                                className={`respnce_btn ${
                                                  reviewSelected.reply_noreply ==
                                                  "1"
                                                    ? "disabledBtnres"
                                                    : ""
                                                } btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center justify-content-center gap-1 h-44-px`}
                                                style={{
                                                  opacity:
                                                    (reviewSelected.platform ===
                                                      "Google" &&
                                                      retrieveData(
                                                        "google_connect_stat",
                                                      ) == "1") ||
                                                    (reviewSelected.platform ===
                                                      "Facebook" &&
                                                      retrieveData(
                                                        "facebook_connect_stat",
                                                      ) == "1")
                                                      ? 0.6
                                                      : 1,
                                                  cursor:
                                                    (reviewSelected.platform ===
                                                      "Google" &&
                                                      retrieveData(
                                                        "google_connect_stat",
                                                      ) == "1") ||
                                                    (reviewSelected.platform ===
                                                      "Facebook" &&
                                                      retrieveData(
                                                        "facebook_connect_stat",
                                                      ) == "1")
                                                      ? "not-allowed"
                                                      : "pointer",
                                                }}
                                              >
                                                {loaderResponse ? (
                                                  <span className="loaderMsgNew"></span>
                                                ) : (
                                                  <>
                                                    <Icon
                                                      icon="ion:paper-plane-outline"
                                                      className="icon text-lg line-height-1"
                                                    />
                                                    <span className="resnceTXT">
                                                      {" "}
                                                      Response
                                                    </span>
                                                  </>
                                                )}
                                              </button>
                                            </div>
                                          </>
                                        ) : (
                                          <div className="sndBttn">
                                            <a
                                              href={`${reviewSelected.online_extranal_url}`}
                                              target="_blanck"
                                              className={`respnce_btn btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center justify-content-center gap-1 h-44-px`}
                                            >
                                              <Icon
                                                icon="ion:paper-plane-outline"
                                                className="icon text-lg line-height-1"
                                              />
                                              <span className="resnceTXT">
                                                {" "}
                                                Response
                                              </span>
                                            </a>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/**-----------------Personal Ai reply------------- */}
                      {showPersonalAi && (
                        <div
                          className="col-xxl-3 col-md-6 col-lg-3 margn_cls"
                          style={{ paddingLeft: "0" }}
                        >
                          <div className="card h-100 p-0 email-card overflow-x-auto d-block pdding_clas_ai">
                            <div className="personl_ai_head">
                              <h4>Pesonalized AI Reply</h4>
                              <AiOutlineClose
                                size={20}
                                className="iconpersnAiCLose"
                                onClick={handleShowPersonalAi}
                              />
                            </div>
                            <div className="center_data_ai">
                              <textarea
                                placeholder="User Prompt"
                                value={inputText}
                                onChange={(e) => setInputText(e.target.value)}
                              ></textarea>

                              <button
                                type="button"
                                className="genrate_resonse_btn"
                                onClick={handleGenerateResponse}
                              >
                                <FaRedo className="relod_icccn" />
                                {hasGenerated
                                  ? "Re-Generate Response"
                                  : "Generate Response"}
                              </button>
                              <div className="prompt_history">
                                <h4>
                                  {" "}
                                  <FaRedo className="Propmt_reload_icon" />{" "}
                                  Prompt History ({prompts.length})
                                </h4>
                                {prompts.map((prompt, index) => (
                                  <div key={index} className="prompt-item">
                                    <p className="typed_txt">{prompt.text}</p>
                                    <p>
                                      Created date :- <span>{prompt.date}</span>
                                    </p>

                                    <div className="select_dlt_bttn">
                                      <button
                                        onClick={() =>
                                          handleSelectPrompt(prompt.text)
                                        }
                                      >
                                        {" "}
                                        <FaCheck className="text-green-500" />
                                        Select
                                      </button>
                                      <button
                                        onClick={() =>
                                          handleDeletePrompt(index)
                                        }
                                      >
                                        {" "}
                                        <FaTrash className="text-red-500" />
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
}

export default Reviews;
